import React from 'react';
import {useI18nContext} from "../../../contexts/I18nContext";
import FastfoodIcon from '@mui/icons-material/Fastfood';
import {Observer} from "mobx-react-lite";
import ButtonType from "../../../ui_components/Button/ButtonType";
import {useCommonContext} from "../../../contexts/CommonContext";
import Box from "../../../ui_components/Box/Box";
import Width from "../../../ui_components/common/enums/Width";
import Alignment from "../../../ui_components/common/enums/Alignment";
import ShowPagination from "../../../ui_components/ShowPagination/ShowPagination";
import MessageCard from "../../../ui_components/MessageCard/MessageCard";
import ShowSellerBasicInfo from "../../Info/ShowSellerBasicInfo/ShowSellerBasicInfo";
import SidePanel from "../../../ui_components/SidePanel/SidePanel";
import {useUserContext} from "../../../contexts/UserContext";
import Access from "../../Access/AllowAccess/Access";
import ShowDeliveryPersonArticleStockProperties from './ShowDeliveryPersonArticleStockProperties';
import clsx from "clsx";
import { useStyles } from './ShowDeliveryPersonArticleStock.style';
import ShowDeliveryPersonArticleStockStore from './ShowDeliveryPersonArticleStockStore';
import ShowImage from '../ShowImage/ShowImage';
import ShowText from '../ShowText/ShowText';
import AddArticleStockButton from '../../Buttons/AddArticleStockButton/AddArticleStockButton';
import Link from '../../../ui_components/Link/Link';
import Article from '../../../entities/Article';
import Currency from '../../../entities/Currency';
import TransferArticleButton from '../../Buttons/TransferArticleButton/TransferArticleButton';
import TransferArticleToWarehouseButton from '../../Buttons/TransferArticleToWarehouseButton/TransferArticleToWarehouseButton';
import Button from '../../../ui_components/Button/Button';
import ArticleSelect from '../../Selects/ArticleSelect/ArticleSelect';
import DownloadArticleStockCSVButton from '../../Buttons/DownloadArticleStockCSVButton/DownloadArticleStockCSVButton';
import ShowArticleStock from '../ShowArticleStock/ShowArticleStock';
import ShowArticleDamagedStock from '../ShowArticleDamagedStock/ShowArticleDamagedStock';


const ShowDeliveryPersonArticleStock: React.FC<ShowDeliveryPersonArticleStockProperties> = ({
                                                                        className = '',
                                                                        deliveryPerson,
                                                                        showAmount = true,
                                                                        linkButtonText = 'Detalles',
                                                                        onClose = () => {
                                                                        },
                                                                    }) => {
    const classes = useStyles();

    const i18n = useI18nContext();
    const commonContext = useCommonContext();
    const userStore = useUserContext();
    const store = new ShowDeliveryPersonArticleStockStore(commonContext, deliveryPerson);

    const handleOnclick = async () => {
        await store.openModal();
    }

    const onCloseModal = () => {
        store.closeModal();
        onClose();
    }

    const onPaginationChange = async (page: number, pageSize: number) => {
        await store.goToPage(page, pageSize);
    }

    const refreshItems = async () => {
        await store.getArticlesStock();
    }

    const onCostSaved = async () => {
        await store.goToPage()
    }

    const onArticleChange = (newArticle?: Article) => (store.articleFilter = newArticle);

    const clearFilter = async () => {
        await store.clearFilter()
    }

    const text = 'Inventario de Artículos';
    if (!userStore.hasAccess(Access.ADD_DELIVERY_COST.valueOf())) {
        return <></>;
    }
    const Info = () => {
        return <div className={clsx(classes.display_field_container, className)}>
                    {showAmount && <><div className={classes.label}>{`Artículos:`}</div>
                    <div className={classes.value}>{deliveryPerson.articleStockTotalAmount}</div></>}
                    <Link text={linkButtonText} onClick={handleOnclick}></Link>
                </div>;
    }
    return <Observer>
        {() => (
            <>
                <SidePanel loading={store.loading} title={text} onClose={onCloseModal} open={store.isModalOpen}
                           className={classes.modal_container}>
                    <div className={classes.contacts_container}>
                        <div className={classes.body}>
                            <Box
                                width={Width.FULL_WIDTH}
                                justifyContent={Alignment.SPACE_BETWEEN}>
                                <ShowSellerBasicInfo name={store.deliveryPerson.name}
                                                     email={store.deliveryPerson.email}
                                                     phone={store.deliveryPerson?.phone} autofill/>
                                <AddArticleStockButton
                                    type={ButtonType.SECONDARY}
                                    onSave={onCostSaved}
                                    entityId={store.deliveryPerson.id}/>
                            </Box>

                            <Box className={classes.filter_container} width={Width.FULL_WIDTH}
                                justifyContent={Alignment.SPACE_BETWEEN}>
                                <div className={classes.filter_items_container}>
                                    <ArticleSelect
                                        fullWidth
                                        label={'Artículo'}
                                        selected={store.articleFilter}
                                        onChange={onArticleChange}/>
                                </div>
                                <div className={classes.filter_buttons_container}>
                                    <Button
                                        onClick={() => {
                                            store.getArticlesStock()
                                        }}
                                        className={classes.search_btn}
                                        type={ButtonType.PRIMARY}
                                        text={i18n.translate("SEARCH")}
                                    />
                                    <Button
                                        onClick={clearFilter}
                                        className={classes.search_btn}
                                        text={i18n.translate("CLEAN")}
                                    />
                                </div>
                            </Box>

                            <Box className={classes.options_container}>
                                <TransferArticleButton
                                        selectedFrom={store.deliveryPerson}
                                        type={ButtonType.SECONDARY} onSave={refreshItems}/>
                                <TransferArticleToWarehouseButton
                                        selectedFrom={store.deliveryPerson}
                                        type={ButtonType.SECONDARY} onSave={refreshItems}/>
                                <DownloadArticleStockCSVButton
                                    id={deliveryPerson.id}
                                    articleId={store.articleFilter?.id}
                                    disabled={store.isEmpty}
                                    type={ButtonType.SECONDARY}
                                />
                            </Box>

                            {!store.isEmpty &&
                            <div className={classes.contacts_table}>
                                <ShowPagination onChange={onPaginationChange}
                                                elementLabel={'Artículos'}
                                                pagination={store.pagination}/>
                                <div>
                                    {store.articlesStock.map((articleStock, i) => (
                                        <div className={classes.cost_info_container}>
                                            <ShowImage imageName={articleStock.articleDefaultImage} width={70} height={70}/>
                                            <ShowText text={articleStock.articleName} className={classes.article_name_container}/>
                                            <div>
                                                <ShowArticleStock amount={articleStock.amount} damagedAmount={articleStock.damagedAmount} assignedAmount={articleStock.assignedAmount} />
                                                <div className={classes.add_btn_link}>
                                                    <AddArticleStockButton
                                                        type={ButtonType.SECONDARY}
                                                        rounded
                                                        onSave={onCostSaved}
                                                        entityId={store.deliveryPerson.id}
                                                        isLinkText={true}
                                                        selectedArticle={new Article(
                                                            articleStock.articleId,
                                                            articleStock.articleName,
                                                            '',
                                                            '',
                                                            '',
                                                            articleStock.articleDefaultImage,
                                                            0,
                                                            Currency.DOLLAR,
                                                            0,
                                                            0,
                                                            0,
                                                            0,
                                                            0
                                                        )}
                                                    />
                                                </div>
                                                <ShowArticleDamagedStock
                                                    damagedAmount={articleStock.damagedAmount}
                                                    entityId={store.deliveryPerson.id}
                                                    articleId={articleStock.articleId}
                                                    onSave={onCostSaved}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <ShowPagination
                                    onChange={onPaginationChange}
                                    elementLabel={'Artículos'}
                                    pagination={store.pagination}/>
                            </div>
                            }
                            {store.isEmpty &&
                            <MessageCard icon={FastfoodIcon} title={i18n.translate("NO_ARTICLE_STOCK_TITLE")}/>}
                        </div>
                    </div>
                </SidePanel>
                <Info/>
            </>
        )}
    </Observer>
}

export default ShowDeliveryPersonArticleStock;
